<template>
  <v-app-bar
    absolute
    color="white"
    height="auto"
    class="py-4 px-2 toolbar-content-padding-y-none position-sticky blur shadow-blur z-index-sticky py-2"
    flat
  >
    <v-container class="max-width-container">
      <v-row>
        <v-col cols="2" class="d-flex align-center">
          <v-menu open-on-hover offset-y bottom min-width="360" max-width="600">
            <template v-slot:activator="{}">
              <v-btn
                :ripple="false"
                color="transparent"
                :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
                class="btn-hover text-white font-weight-light ls-0 align-center"
                depressed
                link
                to="/"
              >
                <v-img
                  src="@/assets/img/logos/oelsnitz-ticket-logo-orange.png"
                  alt="logo"
                  max-width="60"
                  contain
                ></v-img>
              </v-btn>
            </template>
          </v-menu>
        </v-col>

        <v-col cols="6" sm="8" class="mx-auto text-center">
          <template v-if="!$vuetify.breakpoint.mobile">
            <v-menu
              v-for="item in links"
              :key="item.name"
              open-on-hover
              offset-y
              bottom
              min-width="360"
              max-width="800"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="item.sub ? on : null"
                  :ripple="false"
                  color="transparent"
                  :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
                  class="text-dark font-weight-light text-capitalize ls-0 align-center text-lg"
                  depressed
                  link
                  :to="item.link"
                >
                  {{ item.name }}
                  <v-img
                    v-if="item.sub"
                    src="@/assets/img/down-arrow-white.svg"
                    alt="down-arrow"
                    class="arrow ms-1 d-lg-block d-none"
                  />
                </v-btn>
              </template>

              <v-list class="border-radius-xl overflow-hidden">
                <template v-if="item.name == 'Mein Bereich'">
                  <app-bar-pages></app-bar-pages>
                </template>
              </v-list>
            </v-menu>
          </template>
        </v-col>

        <v-col cols="4" sm="2" class="text-right">
          <template v-if="!$vuetify.breakpoint.mobile">
            <v-btn
              v-if="userInformations"
              @click="logout"
              elevation="0"
              color="#fff"
              class="font-weight-bolder py-4 px-4 ms-2"
              :class="'btn-success bg-gradient-warning'"
              href="javascript:;"
              small
            >
              Ausloggen
            </v-btn>
            <v-btn
              v-else
              @click="$store.commit('popLogin', true)"
              elevation="0"
              color="#fff"
              class="font-weight-bolder py-4 px-4 ms-2"
              :class="'btn-success bg-gradient-warning'"
              href="javascript:;"
              small
            >
              Einloggen
            </v-btn>
          </template>

          <v-btn
            v-show="$vuetify.breakpoint.mobile"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-600 text-capitalize drawer-toggler btn-toggler-hover py-3 px-6 rounded-sm"
            color="black"
            @click="dialog = true"
          >
            <div class="drawer-toggler-inner">
              <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
              <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
              <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
            </div>
          </v-btn>

          <v-dialog
            v-model="dialog"
            content-class="position-absolute top-0"
            width="95%"
          >
            <v-card class="card-shadow card-padding">
              <v-card-title
                class="pt-0 px-4 card-padding text-h6 font-weight-bold text-typo justify-space-between border-bottom"
              >
                Oelsnitz-Ticket.de

                <v-btn icon width="31" :ripple="false" @click="dialog = false">
                  <v-icon size="18" class="text-typo">fas fa-times</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="card-padding pb-0 d-flex flex-column px-0">
                <div v-for="item in linksMobile" :key="item.name">
                  <v-btn
                    :ripple="false"
                    text
                    class="text-typo text-capitalize ls-0"
                    depressed
                    link
                    @click="dialog = false"
                    :to="item.link"
                  >
                    {{ item.name }}
                    <v-spacer></v-spacer>
                  </v-btn>
                  <div class="ml-5" v-if="item.links">
                    <v-btn
                      v-for="item2 in item.links"
                      :key="item2.name"
                      :ripple="false"
                      text
                      class="text-typo text-capitalize ls-0"
                      depressed
                      link
                      @click="item2.sub ? null : (dialog = false)"
                      :to="item2.link"
                    >
                      {{ item2.name }}
                      <v-spacer></v-spacer>
                    </v-btn>
                  </div>
                </div>

                <div class="border-bottom my-7"></div>
                <v-btn
                  v-if="userInformations"
                  @click="logout"
                  elevation="0"
                  color="#fff"
                  class="font-weight-bolder py-4 px-4 ms-2"
                  :class="'btn-success bg-gradient-warning'"
                  href="javascript:;"
                  small
                >
                  Ausloggen
                </v-btn>
                <v-btn
                  v-else
                  @click="$store.commit('popLogin', true)"
                  elevation="0"
                  color="#fff"
                  class="font-weight-bolder py-4 px-4 ms-2"
                  :class="'btn-success bg-gradient-warning'"
                  href="javascript:;"
                  small
                >
                  Einloggen
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="loginDialog" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <!-- <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">Einloggen</span>
        </div> -->

        <v-card-text class="card-padding">
          <v-row class="ma-0 pa-0 justify-center">
            <div>
              <v-img
                class="mx-auto"
                src="@/assets/img/logos/oelsnitz-ticket-logo-orange.png"
                alt="logo"
                max-width="80"
                contain
              ></v-img>
              <div
                class="font-weight-bold pt-5 text-h4 text-center text-typo mb-0"
              >
                Anmelden
              </div>
            </div>
          </v-row>

          <v-container class="pa-0">
            <div class="card-padding pt-0">
              <p class="text-danger">
                {{ authMessage }}
              </p>
              <p>
                {{
                  $route.query.message == "notAuthorized"
                    ? "Nicht authorisiert!"
                    : ""
                }}
              </p>
              <v-form @submit.prevent="submitForm" ref="loginForm">
                <v-text-field
                  label="E-Mail-Adresse"
                  placeholder="E-Mail-Adresse"
                  color="#e91e63"
                  required
                  v-model="form.email"
                  class="font-size-input input-style"
                  :rules="emailRules"
                  @keyup.enter="submitForm"
                ></v-text-field>

                <v-text-field
                  ref="passwordFieldLogin"
                  label="Passwort"
                  placeholder="Passwort"
                  color="#e91e63"
                  required
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  class="font-size-input input-style"
                  :rules="min8"
                  @keyup.enter="submitForm"
                >
                  <template v-slot:append>
                    <v-btn
                      icon
                      small
                      @mousedown.prevent="togglePasswordVisibility('login')"
                      tabindex="-1"
                      type="button"
                    >
                      <i class="material-icons-round" style="font-size: 20px;">
                        {{ showPassword ? 'visibility' : 'visibility_off' }}
                      </i>
                    </v-btn>
                  </template>
                </v-text-field>

                <p
                  class="text-body text-warning font-weight-normal"
                  style="cursor: pointer"
                  @click="
                    $store.commit('popLogin', false);
                    resetPasswordDialog = true;
                  "
                >
                  Passwort vergessen?
                </p>

                <v-btn
                  elevation="0"
                  :ripple="false"
                  height="43"
                  :disabled="updating"
                  class="font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                  color="#5e72e4"
                  small
                  type="submit"
                  @click="submitForm"
                  >
                  <span v-if="!updating">Login</span>
                  <v-progress-circular
                    v-else
                    indeterminate
                    color="white"
                    size="20"
                    width="2"
                  ></v-progress-circular>
                </v-btn>
              </v-form>
              <h5
                class="text-h5 text-secondary text-center mt-5 font-weight-normal"
              >
                Du hast noch keinen Account?
              </h5>
              <v-row justify="center">
                <div>
                  <v-btn
                    v-if="!userInformations"
                    :elevation="0"
                    @click="$store.commit('popRegister', true)"
                    class="font-weight-bold text-xs btn-default bg-gradient-warning py-5 px-6 mt-6 mb-2 me-2 ms-auto"
                    color="primary"
                  >
                    Jetzt Registrieren
                  </v-btn>
                </div>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="$store.commit('popLogin', false)"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-normal text-capitalize btn-ls btn-secondary btn-outline-secondary shadow-none bg-transparent py-3 px-6"
            >Abbrechen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetPasswordDialog" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <v-card-text class="card-padding">
          <v-row class="ma-0 pa-0 justify-center">
            <div>
              <v-img
                class="mx-auto"
                src="@/assets/img/logos/oelsnitz-ticket-logo-orange.png"
                alt="logo"
                max-width="80"
                contain
              ></v-img>
              <div
                class="font-weight-bold pt-5 text-h4 text-center text-typo mb-0"
              >
                Passwort zurücksetzen
              </div>
            </div>
          </v-row>

          <v-container class="pa-0">
            <div class="card-padding pt-0">
              <div v-if="!passwordResetSuccessful">
                <div v-if="!passwordSent">
                  <p class="text-body text-warning font-weight-normal">
                    Hier kann das Passwort zurückgesetzt werden. Es wird ein
                    Code an die eingegebene E-Mail-Adresse gesendet.
                  </p>
                  <p class="text-danger">
                    {{ authMessage }}
                  </p>
                  <v-text-field
                    label="E-Mail-Adresse"
                    placeholder="E-Mail-Adresse"
                    color="#e91e63"
                    required
                    v-model="form.email"
                    class="font-size-input input-style"
                    :rules="emailRules"
                  ></v-text-field>

                  <v-btn
                    elevation="0"
                    :ripple="false"
                    height="43"
                    :disabled="resetPasswordTimer > 0 || updatingAuth"
                    class="font-weight-bold text-uppercase btn-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                    :class="resetPasswordTimer > 0 ? '' : 'bg-gradient-default'"
                    color="#5e72e4"
                    small
                    @click="submitResetPassword"
                  >
                    <span v-if="!updatingAuth && resetPasswordTimer === 0"> Code senden </span>
                    <span v-else-if="!updatingAuth && resetPasswordTimer > 0">{{ formatTimer(resetPasswordTimer) }}</span>
                    <v-progress-circular
                      v-else
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                  </v-btn>
                </div>
                <div v-else>
                  <h5 class="text-h5 text-secondary my-5 font-weight-normal">
                    Wir haben Dir einen Code per E-Mail gesendet, bitte gebe Ihn
                    hier ein und wähle ein neues Passwort:
                  </h5>
                  <p class="text-danger" v-if="authMessage">
                    Code nicht korrekt!
                  </p>
                  <v-text-field
                    type="number"
                    label="6-Stelliger Code"
                    placeholder="6-Stelliger Code"
                    color="#e91e63"
                    required
                    v-model="form.verificationCode"
                    class="font-size-input input-style"
                    :rules="min6"
                  ></v-text-field>
                  <v-text-field
                    label="Passwort"
                    placeholder="Passwort"
                    color="#e91e63"
                    required
                    v-model="form.password"
                    type="password"
                    class="font-size-input input-style"
                    :rules="min8"
                  ></v-text-field>
                  <v-btn
                    elevation="0"
                    :ripple="false"
                    height="43"
                    :disabled="form.verificationCode.length != 6"
                    class="font-weight-bold text-uppercase btn-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                    :class="
                      form.verificationCode.length != 6 ||
                      form.password.length < 8
                        ? ''
                        : 'bg-gradient-default'
                    "
                    color="#5e72e4"
                    small
                    @click="submitResetPasswordConfirm"
                    ><span v-if="!updatingAuth">Code bestätigen</span>
                    <v-progress-circular
                      v-else
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                  </v-btn>

                  <v-btn
                    elevation="0"
                    :ripple="false"
                    height="43"
                    :disabled="resetPasswordTimer > 0 || updatingAuth"
                    class="font-weight-bold text-uppercase btn-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                    :class="resetPasswordTimer > 0 ? '' : 'bg-gradient-warning'"
                    color="#5e72e4"
                    small
                    @click="submitResetPassword"
                    ><span v-if="!updatingAuth && resetPasswordTimer === 0"
                      >Neue{{ codeSent ? "r" : "n" }} Code
                      {{ codeSent ? "wurde gesendet" : "senden" }}</span
                    >
                    <span v-else-if="!updatingAuth && resetPasswordTimer > 0">{{ formatTimer(resetPasswordTimer) }}</span>
                    <v-progress-circular
                      v-else
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </div>
              <div v-else>
                <h5 class="text-h5 text-secondary font-weight-normal my-5">
                  Dein Passwort wurde erfolgreich geändert, du kannst dich jetzt
                  einloggen.
                </h5>
                <v-row justify="center">
                  <div>
                    <v-btn
                      v-if="!userInformations"
                      :elevation="0"
                      @click="
                        $store.commit('passwordResetSuccessful', false);
                        resetPasswordDialog = false;
                        $store.commit('popLogin', true);
                      "
                      class="font-weight-bold text-xs btn-default bg-gradient-warning py-5 px-6 mt-6 mb-2 me-2 ms-auto"
                      color="warning"
                    >
                      Einloggen
                    </v-btn>
                  </div>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions
          class="card-padding d-flex justify-end"
          v-if="!passwordResetSuccessful"
        >
          <v-btn
            @click="
              $store.commit('popLogin', false);
              resetPasswordDialog = false;
              // Clear saved state when dialog is cancelled
              localStorage.removeItem('passwordResetCodeRequested');
              localStorage.removeItem('passwordResetEmail');
            "
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-normal text-capitalize btn-ls btn-secondary btn-outline-secondary shadow-none bg-transparent py-3 px-6"
            >Abbrechen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="registerDialog" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <v-card-text class="card-padding">
          <v-row class="ma-0 pa-0 justify-center">
            <div>
              <v-img
                class="mx-auto"
                src="@/assets/img/logos/oelsnitz-ticket-logo-orange.png"
                alt="logo"
                max-width="80"
                contain
              ></v-img>
              <div
                class="font-weight-bold pt-5 text-h4 text-center text-typo mb-0"
              >
                Registrieren
              </div>
            </div>
          </v-row>
          <v-container class="pa-0">
            <div class="card-padding pt-0">
              <div v-if="!accountCreated">
                <p class="text-danger">
                  {{ authMessage }}
                </p>
                <v-text-field
                  label="Benutzername"
                  placeholder="Benutzername"
                  color="#e91e63"
                  required
                  v-model="form.username"
                  class="font-size-input input-style"
                  :rules="rules"
                ></v-text-field>
                <v-text-field
                  label="E-Mail-Adresse"
                  placeholder="E-Mail-Adresse"
                  color="#e91e63"
                  required
                  v-model="form.email"
                  class="font-size-input input-style"
                  :rules="emailRules"
                ></v-text-field>

                <v-text-field
                  ref="passwordFieldRegister"
                  label="Passwort"
                  placeholder="Passwort"
                  color="#e91e63"
                  required
                  v-model="form.password"
                  :type="showPasswordRegister ? 'text' : 'password'"
                  class="font-size-input input-style"
                  :rules="min8"
                >
                  <template v-slot:append>
                    <v-btn
                      icon
                      small
                      @mousedown.prevent="togglePasswordVisibility('register')"
                      tabindex="-1"
                      type="button"
                    >
                      <i class="material-icons-round" style="font-size: 20px;">
                        {{ showPasswordRegister ? 'visibility' : 'visibility_off' }}
                      </i>
                    </v-btn>
                  </template>
                </v-text-field>

                <v-checkbox v-model="form.gdpr" required>
                  <template v-slot:label>
                    <div>
                      Ich habe die
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://oelsnitz-ticket.de/datenschutz"
                            @click.stop
                            v-on="on"
                          >
                            Datenschutzbestimmungen
                          </a>
                        </template>
                        Datenschutz
                      </v-tooltip>
                      gelesen und stimme zu.
                    </div>
                  </template>
                </v-checkbox>

                <v-btn
                  elevation="0"
                  :ripple="false"
                  height="43"
                  :disabled="
                    !form.username ||
                    !form.email ||
                    !form.password ||
                    !form.gdpr
                  "
                  :class="
                    !form.username ||
                    !form.email ||
                    !form.password ||
                    !form.gdpr
                      ? ''
                      : 'bg-gradient-default'
                  "
                  class="font-weight-bold text-uppercase btn-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                  color="#5e72e4"
                  small
                  @click="submitFormRegister"
                  ><span v-if="!updatingAuth">Registrieren</span>
                  <v-progress-circular
                    v-else
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </v-btn>
                <h5
                  class="text-h5 text-secondary text-center mt-5 font-weight-normal"
                >
                  Du hast bereits einen Account?
                </h5>
                <v-row justify="center">
                  <div>
                    <v-btn
                      v-if="!userInformations"
                      :elevation="0"
                      @click="$store.commit('popLogin', true)"
                      class="font-weight-bold text-xs btn-default bg-gradient-warning py-5 px-6 mt-6 mb-2 me-2 ms-auto"
                      color="warning"
                    >
                      Einloggen
                    </v-btn>
                  </div>
                </v-row>
              </div>
              <div v-if="userInformations">
                <h5 class="text-h5 mb-4 text-secondary font-weight-normal">
                  Bitte bestätige Deine E-Mail-Adresse.
                </h5>
                <h5 class="text-h5 text-secondary font-weight-normal">
                  Wir haben Dir einen Code per E-Mail gesendet, bitte gebe Ihn
                  hier ein:
                </h5>
                <p class="text-danger">
                  {{ authMessage }}
                </p>
                <v-text-field
                  type="number"
                  label="6-Stelliger Code"
                  placeholder="6-Stelliger Code"
                  color="#e91e63"
                  required
                  v-model="form.verificationCode"
                  class="font-size-input input-style mt-10"
                  :rules="min6"
                ></v-text-field>
                <v-btn
                  elevation="0"
                  :ripple="false"
                  height="43"
                  :disabled="form.verificationCode.length != 6"
                  class="font-weight-bold text-uppercase btn-default py-2 px-6 me-2 mt-6 mb-2 w-100"
                  :class="
                    form.verificationCode.length != 6
                      ? ''
                      : 'bg-gradient-default'
                  "
                  color="#5e72e4"
                  small
                  @click="verifyEmail"
                  ><span v-if="!updatingAuth">Code bestätigen</span>
                  <v-progress-circular
                    v-else
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </v-btn>

                <v-btn
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="font-weight-bold text-uppercase btn-default bg-gradient-warning py-2 px-6 me-2 mt-6 mb-2 w-100"
                  color="#5e72e4"
                  small
                  @click="$store.dispatch('resendCode')"
                  ><span v-if="!updatingAuth"
                    >Neue{{ codeSent ? "r" : "n" }} Code
                    {{ codeSent ? "wurde gesendet" : "senden" }}</span
                  >
                  <v-progress-circular
                    v-else
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </v-btn>
                <p class="text-center">{{ userInformations.email }}</p>
              </div>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="$store.commit('popRegister', false)"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-normal text-capitalize btn-ls btn-secondary btn-outline-secondary shadow-none bg-transparent py-3 px-6"
            >Abbrechen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>
<script>
import AppBarPages from "./Widgets/AppBarPages.vue";
import AppBarAuthentication from "./Widgets/AppBarAuthentication.vue";
import AppBarApplications from "./Widgets/AppBarApplications.vue";
import AppBarEcommerce from "./Widgets/AppBarEcommerce.vue";
import AppBarDocs from "./Widgets/AppBarDocs.vue";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import { mapGetters } from 'vuex';
Vue.use(VueSweetalert2);

export default {
  name: "app-bar-auth",
  components: {
    AppBarPages,
    AppBarAuthentication,
    AppBarApplications,
    AppBarEcommerce,
    AppBarDocs,
  },
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isRealAdmin',
      'isManager',
      'isPosUser',
      'isChecker',
      'hasManagerRole',
      'hasPosRole',
      'hasCheckerRole'
    ]),
    
    updating() {
      return this.$store.getters.updating;
    },
    passwordResetSuccessful() {
      return this.$store.getters.passwordResetSuccessful;
    },
    passwordSent() {
      return this.$store.getters.passwordSent;
    },
    accountCreated() {
      return this.$store.getters.accountCreated;
    },
    updatingAuth() {
      return this.$store.getters.updatingAuth;
    },
    authMessage() {
      return this.$store.getters.authMessage;
    },
    popLogin() {
      return this.$store.getters.popLogin;
    },
    popRegister() {
      return this.$store.getters.popRegister;
    },
    userInformations() {
      return this.$store.getters.userInformations;
    },
    accountCompleted() {
      return this.$store.getters.accountCompleted;
    },
    codeSent() {
      return this.$store.getters.codeSent;
    },
    
    // Determine admin area route based on ANY role (for navigation on public website)
    adminAreaRoute() {
      // Check if user has ANY admin/manager role (not just current role)
      if (this.isAdmin || this.hasManagerRole) {
        return '/admin/analytics';
      } else if (this.hasPosRole) {
        return '/admin/pos/create-ticket';
      }
      // Checker: Scanner nur in App verfügbar, kein Web-Bereich
      return null;
    },
    
    adminAreaName() {
      // Show the highest priority role the user has
      if (this.isAdmin) {
        return 'Administration';
      } else if (this.hasManagerRole) {
        return 'Manager-Bereich';
      } else if (this.hasPosRole) {
        return 'POS-Bereich';
      }
      // Checker haben keinen eigenen Bereich im Web (Scanner nur in App)
      return null;
    },
    links() {
      var links = [
        {
          name: "Veranstaltungen",
          link: "/events",
          sub: false,
        },
        {
          name: "News",
          link: "/news",
          sub: false,
        },
        {
          name: "So gehts",
          link: "/sogehts",
          sub: false,
        },
      ];

      if (this.userInformations) {
        links.push({
          name: "Mein Bereich",
          sub: true,
        });
        
        // Admin/Manager/POS/Checker Link - direkt nach "Mein Bereich"
        // Zeige Button wenn: echter Admin ODER externe Rollen vorhanden
        if (this.adminAreaRoute && this.adminAreaName && (this.isRealAdmin || this.hasManagerRole || this.hasPosRole)) {
          links.push({
            name: this.adminAreaName,
            link: this.adminAreaRoute,
            sub: false,
          });
        }
      }

      return links;
    },
    linksMobile() {
      var links = [
        {
          name: "Veranstaltungen",
          link: "/events",
          sub: false,
        },
        {
          name: "News",
          link: "/news",
          sub: false,
        },
        {
          name: "So gehts",
          link: "/sogehts",
          sub: false,
        },
      ];

      if (this.userInformations) {
        links.push({
          name: "Mein Bereich",
          sub: true,
          links: [
            {
              name: "Profil",
              link: "/profile",
            },
            {
              name: "Tickets",
              link: "/tickets",
            },
            {
              name: "Zahlungen",
              link: "/invoices",
            },
          ],
        });
        
        // Admin/Manager/POS/Checker Link - direkt nach "Mein Bereich"
        // Zeige Button wenn: echter Admin ODER externe Rollen vorhanden
        if (this.adminAreaRoute && this.adminAreaName && (this.isRealAdmin || this.hasManagerRole || this.hasPosRole)) {
          links.push({
            name: this.adminAreaName,
            sub: false,
            link: this.adminAreaRoute,
          });
        }
      }

      return links;
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.$store.dispatch("userInformations");
    }
    // Restore timer from localStorage
    this.restoreResetPasswordTimer();
  },
  beforeDestroy() {
    // Clear timer interval on component destroy
    if (this.resetPasswordTimerInterval) {
      clearInterval(this.resetPasswordTimerInterval);
      this.resetPasswordTimerInterval = null;
    }
  },
  watch: {
    userInformations() {
      this.loginDialog = false;
      if (!this.userInformations) {
        this.$swal(
          "Abgemeldet",
          "Du hast dich erfolgreich ausgeloggt, bis bald!",
          "success"
        );
      }
    },
    
    // Watch for role changes to update navigation
    hasManagerRole() {
      // Force component update to refresh navigation
      this.$forceUpdate();
    },
    
    hasPosRole() {
      this.$forceUpdate();
    },
    
    hasCheckerRole() {
      this.$forceUpdate();
    },
    
    isAdmin() {
      this.$forceUpdate();
    },
    popLogin() {
      if (this.popLogin) {
        this.loginDialog = true;
        this.registerDialog = false;
      } else {
        this.loginDialog = false;
      }
    },

    popRegister() {
      if (this.popRegister) {
        this.registerDialog = true;
        this.loginDialog = false;
      } else {
        this.registerDialog = false;
      }
    },

    loginDialog() {
      if (!this.loginDialog) {
        this.$store.commit("popLogin", this.loginDialog);
      }
    },

    registerDialog() {
      if (!this.registerDialog) {
        this.$store.commit("popRegister", this.registerDialog);
      }
    },
    resetPasswordDialog(newVal) {
      if (newVal) {
        // Dialog opened - restore timer and state
        this.restoreResetPasswordTimer();
      } else {
        // Dialog closed - clear timer interval
        if (this.resetPasswordTimerInterval) {
          clearInterval(this.resetPasswordTimerInterval);
          this.resetPasswordTimerInterval = null;
        }
      }
    },

    accountCompleted() {
      if (this.accountCompleted) {
        this.registerDialog = false;
      }
    },
  },
  data() {
    return {
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Bitte gebe eine gültige E-Mail-Adresse an",
      ],
      rules: [
        (value) => !!value || "Erforderlich.",
        (value) => (value && value.length >= 3) || "Min 3 Zeichen",
      ],
      min8: [(value) => (value && value.length >= 7) || "Min 8 Zeichen"],
      min6: [
        (value) =>
          (value && value.length > 5 && value.length < 7) || "6 Zeichen",
      ],
      loginDialog: false,
      registerDialog: false,
      resetPasswordDialog: false,
      dialog: false,
      showPassword: false,
      showPasswordRegister: false,
      form: {
        verificationCode: "",
      },
      resetPasswordTimer: 0,
      resetPasswordTimerInterval: null,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutModal");
    },
    submitForm() {
      let payload = {
        email: this.form.email,
        password: this.form.password,
      };
      this.$store.dispatch("loginModal", payload);
    },
    submitResetPassword() {
      if (!this.form.email) return;
      
      // Check if timer is active
      if (this.resetPasswordTimer > 0) {
        return;
      }
      
      let payload = {
        email: this.form.email,
      };
      
      // Save timestamp to localStorage before sending
      const timestamp = Date.now();
      localStorage.setItem('resetPasswordLastSent', timestamp.toString());
      // Save that code was requested and email
      localStorage.setItem('passwordResetCodeRequested', 'true');
      localStorage.setItem('passwordResetEmail', this.form.email);
      
      this.$store.dispatch("submitResetPassword", payload).then(() => {
        // Start timer after successful send
        this.startResetPasswordTimer();
      }).catch(() => {
        // On error, remove saved state
        localStorage.removeItem('passwordResetCodeRequested');
        localStorage.removeItem('passwordResetEmail');
        localStorage.removeItem('resetPasswordLastSent');
      });
    },
    startResetPasswordTimer(initialSeconds = null) {
      // Clear existing interval
      if (this.resetPasswordTimerInterval) {
        clearInterval(this.resetPasswordTimerInterval);
      }
      
      // Set timer to initial seconds or 60 seconds (1 minute)
      if (initialSeconds !== null) {
        this.resetPasswordTimer = initialSeconds;
      } else {
        this.resetPasswordTimer = 60;
      }
      
      // Update timer every second
      this.resetPasswordTimerInterval = setInterval(() => {
        this.resetPasswordTimer--;
        
        if (this.resetPasswordTimer <= 0) {
          clearInterval(this.resetPasswordTimerInterval);
          this.resetPasswordTimerInterval = null;
          this.resetPasswordTimer = 0;
          // Clear localStorage when timer expires
          localStorage.removeItem('resetPasswordLastSent');
          localStorage.removeItem('passwordResetCodeRequested');
          localStorage.removeItem('passwordResetEmail');
        }
      }, 1000);
    },
    restoreResetPasswordTimer() {
      const lastSent = localStorage.getItem('resetPasswordLastSent');
      const codeRequested = localStorage.getItem('passwordResetCodeRequested');
      const savedEmail = localStorage.getItem('passwordResetEmail');
      
      if (!lastSent || !codeRequested) {
        this.resetPasswordTimer = 0;
        return;
      }
      
      const lastSentTime = parseInt(lastSent);
      const now = Date.now();
      const elapsed = Math.floor((now - lastSentTime) / 1000); // seconds
      const remaining = 60 - elapsed;
      
      if (remaining > 0) {
        // Timer still active - start with remaining seconds
        this.startResetPasswordTimer(remaining);
        
        // Restore email and passwordSent state if code was requested
        if (savedEmail) {
          this.form.email = savedEmail;
          this.$store.commit('passwordSent', true);
        }
      } else {
        // Timer expired - clear all saved state
        this.resetPasswordTimer = 0;
        localStorage.removeItem('resetPasswordLastSent');
        localStorage.removeItem('passwordResetCodeRequested');
        localStorage.removeItem('passwordResetEmail');
      }
    },
    formatTimer(seconds) {
      return `Code erneut senden in: ${seconds}s`;
    },
    submitResetPasswordConfirm() {
      if (!this.form.verificationCode.length == 6) return;
      if (!this.form.password.length > 7) return;
      let payload = {
        passwordResetCode: this.form.verificationCode,
        password: this.form.password,
      };
      this.$store.dispatch("submitResetPasswordConfirm", payload).then(() => {
        // Clear saved state on successful password reset
        localStorage.removeItem('resetPasswordLastSent');
        localStorage.removeItem('passwordResetCodeRequested');
        localStorage.removeItem('passwordResetEmail');
      });
    },
    togglePasswordVisibility(type, event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      
      const refName = type === 'login' ? 'passwordFieldLogin' : 'passwordFieldRegister'
      const field = this.$refs[refName]
      
      if (!field) {
        if (type === 'login') {
          this.showPassword = !this.showPassword
        } else {
          this.showPasswordRegister = !this.showPasswordRegister
        }
        return
      }
      
      // Find the actual input element
      const input = field.$el ? field.$el.querySelector('input') : null
      if (!input) {
        if (type === 'login') {
          this.showPassword = !this.showPassword
        } else {
          this.showPasswordRegister = !this.showPasswordRegister
        }
        return
      }
      
      // Save cursor position and input value length
      const cursorPosition = input.selectionStart || input.value.length
      const valueLength = input.value.length
      
      // Toggle visibility
      if (type === 'login') {
        this.showPassword = !this.showPassword
      } else {
        this.showPasswordRegister = !this.showPasswordRegister
      }
      
      // Restore cursor position after DOM update
      this.$nextTick(() => {
        const newInput = field.$el ? field.$el.querySelector('input') : null
        if (newInput) {
          // Focus and set cursor position
          newInput.focus()
          // Ensure cursor position is within bounds
          const safePosition = Math.min(cursorPosition, valueLength)
          newInput.setSelectionRange(safePosition, safePosition)
        }
      })
    },
    submitFormRegister() {
      let payload = {
        email: this.form.email,
        password: this.form.password,
        username: this.form.username,
      };
      this.$store.dispatch("signup", payload);
    },
    verifyEmail() {
      let payload = {
        verificationCode: this.form.verificationCode,
      };
      this.$store.dispatch("verifyEmail", payload);
    },
  },
};
</script>
